<template>
	<div>
		<a href="#/backoffice/admin">← back</a>
		<h1 class="text-center">{{userObj._id?'EDIT user - '+userObj.company_name:'Add new user'}}</h1>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="panel panel-login">
					<div class="panel-body">
						<div class="row">
							<div class="col-lg-12">
								<ValidationObserver ref="form">
									<form id="login-form" role="form" name="userForm">
										<h3>Company/Organization details</h3>
										<validation-provider rules="required" v-slot="{errors,classes }">
											<div class="form-group">
												<label>company name</label>
												<input type="text" name="company_name" id="company_name" class="form-control"
												       placeholder="company_name" value="" v-model="userObj.company_name" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<validation-provider rules="required" v-slot="{errors,classes }">
											<div class="form-group">
												<label>company_id</label>
												<input type="text" name="company_id" id="company_id" class="form-control"
												       placeholder="company_id" v-model="userObj.company_id" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<validation-provider rules="required" v-slot="{errors,classes }">
											<div class="form-group">
												<label>company_email</label>
												<input type="email" name="company_email" id="company_email" class="form-control"
												       placeholder="company_email" v-model="userObj.company_email" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<div class="form-group">
											<label>company_phone</label>
											<input type="tel" name="company_phone" id="company_phone" class="form-control"
											       placeholder="company_phone" v-model="userObj.company_phone" required>
										</div>
										<div class="form-check">
											<input type="checkbox" class="form-check-input" name="isDemoUser" id="isDemoUser" v-model="userObj.isDemoUser">
											<label class="form-check-label">
												Is demo user
											</label>
										</div>

										<h3>Login details</h3>
										<validation-provider rules="required|email" v-slot="{errors,classes }">
											<div class="form-group">
												<label>user_email</label>
												<input type="email" name="user_email" id="user_email" class="form-control"
												       placeholder="user_email" value="" v-model="userObj.user_email" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<validation-provider rules="required|min:6" v-slot="{errors,classes }">
											<div class="form-group">
												<label>user_password</label>
												<input type="password" name="user_password" id="user_password" class="form-control"
												       placeholder="password" v-model="userObj.user_password" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>

										<h3>Contacts</h3>
										<div v-for="(contact,$index) in userObj.contacts" class="offset-md-1">
											<validation-provider rules="required" v-slot="{errors,classes }">
												<div class="form-group">
													<label>contact.name</label>
													<input type="text" name="name" :id="'name'+$index" class="form-control"
													       placeholder="name" value="" v-model="contact.name" :class="classes">
													<div class="invalid-feedback">{{ errors[0] }}</div>
												</div>
											</validation-provider>
											<div class="form-group">
												<label>contact.phone</label>
												<input type="tel" name="phone" :id="'phone'+$index" class="form-control"
												       placeholder="phone" v-model="contact.phone">
											</div>
											<validation-provider rules="required" v-slot="{errors,classes }">
												<div class="form-group">
													<label>contact.email</label>
													<input type="email" name="email" :id="'email'+$index" class="form-control"
													       placeholder="email" v-model="contact.email" :class="classes">
													<div class="invalid-feedback">{{ errors[0] }}</div>
												</div>
											</validation-provider>
											<div class="form-group">
												<label>contact.duty (CEO\CTO etc...)</label>
												<input type="tel" name="duty" :id="'duty'+$index" class="form-control"
												       placeholder="duty" v-model="contact.duty">
											</div>
											<button type="button" class="btn btn-light btn-sm mr-1" @click="addContact()">
												Add contact
											</button>
											<button type="button" class="btn btn-warning btn-sm mr-1" v-show="$index>0" @click="removeContact($index)">
												remove contact
											</button>
											<hr/>
										</div>

										<div class="form-group">
											<div class="row">
												<div class="col-sm-6 col-sm-offset-3">
													<input type="button" class="form-control btn btn-primary" value="Save user"
													       @click="saveUser()">
												</div>
											</div>
										</div>
									</form>
								</ValidationObserver>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ApiService from "../../../libs/ApiService";

	const defaultContact = {
		name: null,
		phone: null,
		email: null,
		duty: null,
	}
	export default {
		name: "AdminUserForm",
		data() {
			return {
				userObj: {
					company_name: null,
					company_id: null,
					company_email: null,
					company_phone: null,
					isDemoUser: true,
					user_email: null,
					user_password: null,
					contacts: [defaultContact]
				}
			}
		}, methods: {

			async saveUser() {
				let $action = (this.userObj._id) ? ApiService.put : ApiService.post;
				let url = '/admin/user' + (this.userObj._id ? "/" + this.userObj._id : '');
				try {
					await $action(url, this.userObj);
					this.$router.push('/backoffice/admin');
				} catch (axiosError) {
					alert(axiosError.response.data.errMsg);
				}
			},
			addContact() {
				this.userObj.contacts.push(defaultContact);
			},
			removeContact(index) {
				this.userObj.contacts.splice(index, 1);
			}

		},
		async created() {
			let uuid = this.$route.params.uuid;
			if (uuid) {
				let res = await ApiService.get('/admin/user/' + uuid);
				// res.data is always a list even for a single user
				this.userObj = res.data[0];
				if (!this.userObj.contacts) {
					this.userObj.contacts = [defaultContact];
				}
			}
		}
	}
</script>

<style scoped>

</style>
